module.exports = __webpack_public_path__ + "img/rsz_2banner01.cbf42225.jpg";